export enum ReviewsIoStoreId {
  DE = 'www.petsdeli.de',
  CH = 'www.petsdeli.ch',
  NL = 'www.petsdeli.nl',
}
